<template>
    <div id="banner">
        <section class="hero is-medium">
            <div class="hero-body">
                <div class="container">
                    <div class="columns">
                        <div class="column is-6 ">
                            <h1 class="title">
                                {{$t('BannerTitle')}}
                            </h1>
                            <h3 class="subtitle">
                                {{$t('BannerSubTitle')}}
                            </h3>
                            <div class="columns ">
                                <div class="column is-4 is-6-mobile">
                                    <a href="https://apps.apple.com/nl/app/horse-traq/id1482126463" traget="_blank">
                                        <img :src="$t('AppStoreButton')" style="height: 40px;">
                                    </a>
                                </div>
                                <div class="column is-4  is-6-mobile">
                                    <a href="https://play.google.com/store/apps/details?id=nl.HorseTraq" traget="_blank">
                                        <img :src="$t('PlayStoreButton')" style="height: 40px;">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6 is-hidden-touch">
                            <div class="app-teaser">
                                <img  src="../assets/images/banner/appTeaser.png" >
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
    </div>
    
</template>

<script>
export default {
  name: 'Banner',
  data () {
      return {
      }
  }
}
</script>

